import React from "react";
import CustomPopup from "../../../../Common/CustomPopup";
import OutlineButton from "../../../../Common/Buttons/OutlineButton";
import styles from "./index.module.css";
import calendarIcon from "../../../../../assets/images/calendarTimeAdd.svg";
import arrowBlue from "../../../../../assets/images/arrowRightCircle.svg";
import arrowRed from "../../../../../assets/images/arrowRightCircleRed.svg";
import calendarCancelIcon from "../../../../../assets/images/calendarActionIcon.png";
const EditTrialClassPopup = ({
  open,
  onClose,
  trialClass = {},
  onReschedule,
  onCancel,
}) => {
  const { date, time, subject, mentorName, mentorAvatar } = trialClass;

  return (
    <CustomPopup
      open={open}
      onClose={onClose}
      maxWidth="sm"
      className={styles.editTrialClass}
      showCloseButton={true}
      disableBackdropClick={false}
      padding="32px 24px 24px 24px"
    >
      <h2 className={styles.popupTitle}>Edit trial class</h2>

      <div className={styles.section}>
        <p className={styles.sectionLabel}>Trial class details:</p>

        <div className={styles.detailsCard}>
          <p className={styles.dateTime}>
            {date} &bull; {time}
          </p>
          <div className={styles.metaRow}>
            <span className={styles.subject}>{subject}</span>
            <span className={styles.mentor}>
              {mentorAvatar ? (
                <img
                  src={mentorAvatar}
                  alt={mentorName}
                  className={styles.avatar}
                />
              ) : (
                <span className={styles.avatarFallback}>
                  {mentorName?.charAt(0)?.toUpperCase()}
                </span>
              )}
              <span className={styles.mentorName}>{mentorName}</span>
            </span>
          </div>
        </div>
      </div>

      <div className={styles.section}>
        <p className={styles.sectionLabel}>Pick what you want to do:</p>

        <div className={styles.actionsGrid}>
          <div className={styles.actionCard}>
            <img src={calendarIcon} alt="" className={styles.actionIcon} />
            <h3 className={styles.actionTitle}>Reschedule trial class</h3>
            <p className={styles.actionDesc}>
              Choose a new time that works better for you
            </p>
            <OutlineButton
              onClick={onReschedule}
              endIcon={<img src={arrowBlue} alt="" width={20} height={20} />}
              className={styles.rescheduleBtn}
            >
              Proceed to reschedule
            </OutlineButton>
          </div>

          <div className={styles.actionCard}>
            <img
              src={calendarCancelIcon}
              alt=""
              className={styles.actionCancelIcon}
            />
            <h3 className={styles.actionTitle}>Cancel trial class</h3>
            <p className={styles.actionDesc}>
              Cancel your scheduled trial session. Your class credits will be
              refunded.
            </p>
            <OutlineButton
              onClick={onCancel}
              endIcon={<img src={arrowRed} alt="" width={20} height={20} />}
              className={styles.cancelBtn}
            >
              Proceed to cancel
            </OutlineButton>
          </div>
        </div>
      </div>
    </CustomPopup>
  );
};

export default EditTrialClassPopup;
